import React from 'react'
import { NavBackButton } from '../NavBar/NavBackButton'

interface DrawerModalProps {
  children: React.ReactNode
  title: String
  handleClose: () => void
  hasTabBar: boolean
}

export const DrawerModal = ({ children, title, handleClose, hasTabBar }: DrawerModalProps) => {
  return (
    <div className='fixed left-0 right-0 bottom-0 backdrop-brightness-50 h-full z-50'>
      <div
        className={`bg-white max-w-[500px] mx-auto fixed left-0 right-0 bottom-0 rounded-t-3xl shadow-2xl py-[20px]`}
      >
        <div className='container mx-auto px-[15px]'>
          <div className='flex items-center text-md gap-5 mb-4'>
            <NavBackButton action={'close'} onClick={handleClose} />
            <div>{title}</div>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
